export default function setRem() {
  // document.getElementsByTagName("html")[0].style.fontSize = document.body.clientHeight / 10.8 + "px";
  document.getElementsByTagName("html")[0].style.fontSize =
    document.body.clientWidth > 1920
      ? "100px"
      : document.body.clientWidth / 19.2 + "px";
  // document.getElementsByTagName("html")[0].style.fontSize = "100px";
}
